module.exports = __webpack_public_path__ + "bcc5587d98c149928cd1d54841fff61a.glb";